import React, { } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'

// Sections
import OrderSummary from 'views/shared/sections/order-summary'

// Assets

const OrderSummaryModal = ({mode, className, orderCode, onNotificationSent, close, closeBtn, ...props}) => {
	return (
		<div className={className} data-ordercode={orderCode}>
			<div className="modal-header">
				<h1 className="header-title">
					{mode === 'detail' ? 'Sipariş Detayı' : 'Ödeme Linki'}
				</h1>
				{closeBtn}
			</div>
			<OrderSummary
				onError={close}
				mode={mode}
				className="modal-content dark"
				onNotificationSent={() => { if(onNotificationSent) { onNotificationSent() }}}
				orderCode={orderCode} />
			<div className="modal-controls">
				<Btn
					big gray outline
					onClick={close}>
					Tamam
				</Btn>
			</div>
		</div>
	)
}

OrderSummaryModal.defaultProps = {
	className: '',
	containerClass: 'modal-order-summary mobile-full',
	name: 'order-summary',
	title: false,
	content: false,
	source: false,
	mode: 'link',
}

export default OrderSummaryModal